module.exports = __webpack_public_path__ + "img/35year.6105036b.svg";